import { Direction } from '@angular/cdk/bidi';
import { Overlay } from '@angular/cdk/overlay';
import { Component, Inject, OnInit } from '@angular/core';
import { PopUpComponent } from 'src/app/@shared/components/pop-ups/pop-up.component';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { eFavoriteType } from 'src/app/modules/route-planner/enums/favorite/favorite-type.enum';
import { FavoriteLine } from 'src/app/modules/route-planner/interfaces/favorites/favorite-line.interface';
import { FavoriteLines } from 'src/app/modules/route-planner/interfaces/favorites/favorite-lines.interface';
import { FavoriteRoute } from 'src/app/modules/route-planner/interfaces/favorites/favorite-route.interface';
import { FavoriteStation } from 'src/app/modules/route-planner/interfaces/favorites/favorite-station.interface';
import { FavoriteStations } from 'src/app/modules/route-planner/interfaces/favorites/favorite-stations.interface';
import { Favorite } from 'src/app/modules/route-planner/interfaces/favorites/favorite.interface';
import { FavoritesService } from 'src/app/modules/route-planner/services/favorites/favorites.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { DELETE, DELETE_FAVORITE, CANCEL, CLOSE } from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    selector: 'app-delete-favorite-pop-up',
    templateUrl: './delete-favorite-pop-up.component.html',
    styleUrls: ['./delete-favorite-pop-up.component.scss'],
    standalone: false
})
export class DeleteFavoritePopUpComponent
  extends PopUpComponent
  implements OnInit
{
  direction: Direction;

  deleteText: string
  cancelText: string
  deleteFavoriteText: string
  /**
   * a11y: localized aria-label for the new top close (X) button. The popup
   * previously offered only Delete / Cancel actions; the audit requires a
   * close button at the top of every popup as the initial focus target.
   * Activating it returns `undefined` from closeCard, equivalent to Esc/Cancel.
   */
  closeText: string

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,

    @Inject(POPUP_DATA)
    public readonly data: { favorite: any },
    private readonly languageService: LanguageService,
    private readonly favoriteService: FavoritesService
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initializeMultiLanguageTexts();
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction;
      this.deleteText = DELETE[language.language]
      this.cancelText = CANCEL[language.language]
      this.deleteFavoriteText = DELETE_FAVORITE[language.language]
      this.closeText = CLOSE[language.language]
    });
  }

  deleteFavorite() {
    switch (this.data.favorite.type) {
      case eFavoriteType.STATIONS:
        const favoriteStations = this.favoriteService.favorites?.stations;
        const newStations = favoriteStations?.stations
          ? [...favoriteStations?.stations]
          : [];
        newStations.splice(
          newStations.findIndex(
            (station) => station.stopcode == this.data.favorite.stopcode
          ),
          1
        );

        const newFavoriteStations: FavoriteStations = {
          ...favoriteStations,
          stations: newStations,
          type: eFavoriteType.STATIONS,
        };
        this.favoriteService.updateFavorite(newFavoriteStations);
        break;
      case eFavoriteType.LINES:
        const favoriteLines = this.favoriteService.favorites?.lines;
        const newLines = favoriteLines?.routes
          ? [...favoriteLines?.routes]
          : [];
        newLines.splice(
          newLines.findIndex(
            (route) => route.routeId == this.data.favorite.routeId
          ),
          1
        );
        const newFavoriteLines: FavoriteLines = {
          ...favoriteLines,
          routes: newLines,
          type: eFavoriteType.LINES,
        };

        this.favoriteService.updateFavorite(newFavoriteLines);
        break;
      case eFavoriteType.ROUTES:
        this.favoriteService.removeFavorite(this.data.favorite);
        break;
    }

    this.closeCard();
  }
}
